// BREAKPOINTS
export const sm = "640px";
export const md = "768px";
export const lg = "1024px";
export const xl = "1280px";
export const xxl = "1536px";
